import React from "react"

import StarBlue from "../../images/star-blue.svg"
import {
  DEFAULT_VARIATIONS,
  getVariationsForSignal,
  pickRandomValue,
} from "./signal-constants"

export const CaseStudySignalsGrid = ({
  signalsData,
  slotStates,
  allSlotsStopped,
  animationSettings,
  signalsColumns,
  formatSignalTitle,
}) => {
  if (!signalsData.length) {
    return null
  }

  return (
    <div className="case-study-signals-container my-6">
      {allSlotsStopped && (
        <img
          src={StarBlue}
          alt=""
          aria-hidden="true"
          className="case-study-signals-star"
        />
      )}

      <div
        className="case-study-signals-grid"
        style={{ gridTemplateColumns: `repeat(${signalsColumns}, 1fr)` }}
      >
        {signalsData.map((signal, index) => {
          const slotState = slotStates[index]
          const options = slotState?.options?.length
            ? slotState.options
            : getVariationsForSignal(signal.title)
          const safeOptions = options.length ? options : DEFAULT_VARIATIONS

          const currentValue = slotState?.currentValue ?? safeOptions[0]
          const previousValue = slotState?.previousValue
          const nextValue =
            slotState?.nextValue ??
            pickRandomValue(
              safeOptions,
              slotState?.currentValue ?? safeOptions[0]
            )

          const phaseClass =
            slotState?.phase === "animating" ? "is-animating" : "is-resting"
          const tick = slotState?.tick ?? 0

          return (
            <div key={signal.title + index} className="case-study-signal-card">
              <div className="case-study-signal-card-header">
                <span className="case-study-signal-card-title">
                  {formatSignalTitle(signal.title)}
                </span>
              </div>

              <div className="case-study-signal-card-body">
                <div
                  className={`case-study-signal-card-value-wrapper ${phaseClass}`}
                  style={{
                    "--slot-animation-duration": `${animationSettings.slotDuration}ms`,
                    "--slot-item-height": "2rem",
                  }}
                >
                  {phaseClass === "is-animating" && previousValue && (
                    <span
                      key={`prev-${index}-${tick}`}
                      className="case-study-signal-card-value is-exiting"
                    >
                      {previousValue}
                    </span>
                  )}
                  <span
                    key={`current-${index}-${tick}`}
                    className={`case-study-signal-card-value ${
                      phaseClass === "is-animating"
                        ? "is-entering"
                        : "is-static"
                    }`}
                  >
                    {currentValue}
                  </span>
                  <span
                    key={`next-${index}-${tick}`}
                    className="case-study-signal-card-value is-upcoming"
                  >
                    {nextValue}
                  </span>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
